</<template>
    <common-login @user-info='login'></common-login>
</template>

<script>
import CommonLogin from '@/components/CommonLogin.vue'
import { getDownloadFiles } from '@/api'
import { toErrorMessage } from '@/common'

export default {
  title: '',
  components: {
    CommonLogin
  },
  methods: {
    login: function (event) {
      this.$store.commit('progress/setLoading', true)
      getDownloadFiles(event.exchangeId, event.email, event.password)
        .then(response => {
          this.$store.commit('receiver/setExchange', response)
          this.$store.commit('receiver/setUserName', this.email)
          localStorage.setItem('loginType', 'download')
          this.$router.push({ name: 'receiverList' })
        })
        .catch(e => {
          // エラー内容でメッセージを切り替える
          const errorMessage = toErrorMessage(e.response.status)
          event.errorMessageList.push(errorMessage)
          this.$store.commit('progress/setLoading', false)
        })
    }
  }
}
</script>
<style>
</style>
